import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Game } from "@/components/Game";
import "./styles.css";

const container = document.getElementById("app");

if (!container) {
  throw new Error("Missing #app root element");
}

createRoot(container).render(
  <StrictMode>
    <Game />
  </StrictMode>,
);
